export default __webpack_public_path__ + "static/media/attention4.7c386d09.mp3";